import React from "react";
import { Container } from "react-bootstrap";
import "../../incidentes.css";

const guias = [
  { titulo: "Instalación de Software", href: "doc/InstalacionSoftware_001.docx" },
  { titulo: "Mantenimiento Correctivo", href: "doc/Manto-Correctivo_001.docx" },
  { titulo: "Mantenimiento Preventivo", href: "doc/Manto-Preventivo_001.docx" },
  { titulo: "PoCs", href: "doc/PoCs_001.docx" },
  { titulo: "Site Survey", href: "doc/SiteSurvey_001.docx" },
];

const GuiasTrabajoOnSite = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Guías Trabajo On Site</h1>
        </div>
        <div className="orgproc-grid-3col">
          {guias.map((guia, index) => (
            <div className="orgproc-card" key={guia.titulo}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Proceso #{index + 1}</div>
                <div className="orgproc-card-title">{guia.titulo}</div>
                <p className="orgproc-card-desc">Guía</p>
                <div className="orgproc-card-actions">
                  <a
                    className="orgproc-card-btn"
                    href={`${bucketUrl}/${guia.href}`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar Formato →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default GuiasTrabajoOnSite;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
